module.exports = __webpack_public_path__ + "static/media/Dragon363_1c.b101cc11.svg";